module.exports = "pegasus/assets/background-patterns/default-automotive-theme.jpg";